/*
 * vendor 文件模块化导出
 *
 * 把 .min.js 内容当字符串引入，运行时通过 Blob URL 注入 <script>。
 * 这样整个 aiClerk 模块完全自包含，无需依赖 public/ 或外部 CDN。
 *
 * 文件加 .txt 后缀避开 Vite 对 JS 的默认处理；
 * Vite ?raw 查询把文件内容当纯文本字符串读入。
 *
 * 升级版本：
 *   npm install <pkg> --no-save
 *   cp node_modules/<pkg>/dist/<file>.min.js src/pages/aiClerk/vendor/<file>.min.js.txt
 *   npm uninstall <pkg>
 */

import jszipSrc from './jszip.min.js.txt?raw'
import docxPreviewSrc from './docx-preview.min.js.txt?raw'
import mermaidSrc from './mermaid.min.js.txt?raw'

export const JSZIP_SOURCE: string = jszipSrc
export const DOCX_PREVIEW_SOURCE: string = docxPreviewSrc
export const MERMAID_SOURCE: string = mermaidSrc

// ─── 注入工具 ─────────────────────────────────────────

const injected = new Set<string>()

/** 把 JS 源代码字符串以 Blob 形式注入为 <script>，并等待执行完毕 */
export function injectScriptFromSource(
  name: string,
  source: string
): Promise<void> {
  if (injected.has(name)) return Promise.resolve()
  return new Promise((resolve, reject) => {
    try {
      const blob = new Blob([source], { type: 'application/javascript' })
      const url = URL.createObjectURL(blob)
      const script = document.createElement('script')
      script.src = url
      script.async = false
      script.onload = () => {
        injected.add(name)
        URL.revokeObjectURL(url)
        resolve()
      }
      script.onerror = () => {
        URL.revokeObjectURL(url)
        reject(new Error(`vendor 脚本加载失败: ${name}`))
      }
      document.head.appendChild(script)
    } catch (e) {
      reject(e)
    }
  })
}
